import React from "react";
import { Route } from "react-router-dom";
import ForgotPassword from "../components/ForgotPassword/updatePassword";

export function forgotPassword() {
  return <Route path="/forgot-password" element={<ForgotPassword />} />;
}
